import React from 'react';
import { Button, Container, Form, Modal } from 'react-bootstrap';
import { useBannerContext } from '../../Context/index';
import { useState } from 'react';
import AddAppBannerForum from './AppBanner/AddAppBannerForum';
import CustomButton from '../Common/CustomButton/CustomButton';
import AddWebBannerForum from './WebBanner/AddWebBannerForum';

const PLATFORM_OPTIONS = ['Mobile App', 'Desktop Web'] as const;

const BannerAddModal: React.FC = () => {
    const { addBannerModal, setAddBannerModal } = useBannerContext();
    const [platform, setPlatform] = useState('');

    return (
        <Modal show={addBannerModal} animation={false}>
            <Container className="pt-3">
                <Form.Label className="m-2">Platform</Form.Label>
                <div className="d-flex gap-2 ms-2 mb-2">
                    {PLATFORM_OPTIONS.map(option => (
                        <Button
                            key={option}
                            type="button"
                            variant={
                                platform === option ? 'success' : 'outline-success'
                            }
                            onClick={() => setPlatform(option)}
                        >
                            {option}
                        </Button>
                    ))}
                </div>
            </Container>
            {!platform && (
                <Container
                    style={{
                        height: '50vh',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'space-around',
                        alignItems: 'flex-start',
                    }}
                >
                    Please Select A Platform
                    <CustomButton onClick={() => setAddBannerModal(false)}>
                        Close
                    </CustomButton>
                </Container>
            )}
            {platform && platform === 'Mobile App' && <AddAppBannerForum />}
            {platform && platform === 'Desktop Web' && <AddWebBannerForum />}
        </Modal>
    );
};

export default BannerAddModal;
